import {
  PlatformTypeEnum,
  ROUTE_MEASURE,
  ROUTE_MEASURE_GRAIN,
  ROUTE_PARTIES,
  ROUTE_PARTIES_GRAIN,
  ROUTE_REPORTS,
  ROUTE_REPORTS_GRAIN,
} from '@/common/constants';
import { LogoIconGrain } from '@/common/icons/LogoIconGrain';
import { LogoIconLight } from '@/common/icons/LogoIconLight';
import { NavbarItem } from '@/components/navbar/NavbarItem';
import { NavUser } from '@/components/ui/nav-user';
import useStore from '@/lib/store';
import { Plus } from 'lucide-react';
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button } from '../ui/button';

export const Navbar: FC = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const { user } = useStore();
  const isCotton = PlatformTypeEnum.COTTON === user?.platform_type;

  const links = useMemo(
    () => [
      {
        label: t('checked.loads'),
        pathname: '/loads',
      },
      {
        label: t('parties'),
        pathname: isCotton ? ROUTE_PARTIES : ROUTE_PARTIES_GRAIN,
      },
      {
        label: t('reports'),
        pathname: isCotton ? ROUTE_REPORTS : ROUTE_REPORTS_GRAIN,
      },
    ],
    [t, isCotton],
  );

  return (
    <div className="w-full flex-h-center-between bg-dark px-5">
      {isCotton ? <LogoIconLight /> : <LogoIconGrain />}

      <div className="flex-h-center space-x-2">
        {links?.map((link) => (
          <NavbarItem
            key={link.pathname}
            label={link.label}
            pathname={link.pathname}
            activeLink={pathname.includes(link.pathname)}
            navigate={navigate}
          />
        ))}
      </div>

      <div className="flex items-center gap-2">
        <Button
          className="text-white text-sm font-medium bg-green-500"
          onClick={() => {
            // setLoad(null);
            if (isCotton) {
              navigate(ROUTE_MEASURE);
            } else {
              navigate(ROUTE_MEASURE_GRAIN);
            }
          }}
          disabled={pathname.includes(ROUTE_MEASURE_GRAIN)}
        >
          <Plus size="20" color="white" />
          {t('create.load')}
        </Button>
        <div className="relative">
          <NavUser user={user} />
        </div>
      </div>
    </div>
  );
};
